"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__genericListDto = void 0;
// Prevent file from being removed during compilation (needed for sourcemaps)
exports.__genericListDto = true;
//# sourceMappingURL=generic-list.dto.js.map